angular.module('eStories.specialTrial', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.specialTrial', {
                url: '2mo2cdt',
                views: {
                    'mainView@': {
                        templateUrl: 'home/specialTrial/2mo2cdt.tmpl.html',
                        controller: 'SpecialTrialCtrl as specialTrialCtrl'
                    }
                }
            })
            .state('eStories.navbars.groupon2mo2cdt', {
                url: 'groupon2mo2cdt',
                views: {
                    'mainView@': {
                        templateUrl: 'home/specialTrial/groupon2mo2cdt.tmpl.html',
                        controller: 'SpecialTrialCtrl as specialTrialCtrl'
                    }
                }
            });
    }])

    .controller('SpecialTrialCtrl', [
        'CatalogModel',
        'BillingModel',
        '$rootScope',
        '$state',
        'AccountModel',
        '$location',
        'CtaModel',
        'GA',
        function (CatalogModel, BillingModel, $rootScope, $state, AccountModel, $location, CtaModel, GA) {
            var specialTrialCtrl = this;

            GA.trackPageView($location.path());

            specialTrialCtrl.cta = CtaModel;

            if ($location.path().indexOf('2mo2cdt') > -1) {
                $rootScope.$broadcast('2mo2cdtSignUp');
            }

            $rootScope.$on('subscriptionDetailsLoaded', function () {
                if (AccountModel.isUserLoggedIn != null && AccountModel.isMember()) {
                    $state.go('eStories.navbars.home');
                }
            });

            if (AccountModel.isUserLoggedIn != null && AccountModel.isMember()) {
                $state.go('eStories.navbars.home');
            }

            specialTrialCtrl.signUpOrConfirmTrial = function () {
                AccountModel.signUpOrConfirmTrial();
            };

            specialTrialCtrl.visibleTab = "tab0";

            specialTrialCtrl.initSpecialTrial = async () => {
                const response = await CatalogModel.getSectionList(['LANDING_FEATURE_CAROUSEL']);
                var sectionList = response.sectionList;
                specialTrialCtrl.landingSectionsMap = {};
                specialTrialCtrl.landingSectionItemListMap = {};
                for (var i = 0; i < sectionList.length; i++) {
                    var section = sectionList[i];
                    specialTrialCtrl.landingSectionsMap = [];
                    if (AccountModel.trialType == "twoMo2cdt" && section.name == 'THEMED_UNREGISTERED') {
                        specialTrialCtrl.landingSectionsMap.push(section);
                        break;
                    }
                    if ($location.path().indexOf('groupon2mo2cdt') > -1) {
                        if (AccountModel.trialType == "twoMo2cdt" && section.name == 'THEMED_GROUPON_2MO2CDT') {
                            specialTrialCtrl.landingSectionsMap.push(section);
                            break;
                        }
                    }
                }
            };

            specialTrialCtrl.initSpecialTrial().then();
        }]);
